import {SlideConfig} from "./SlideConfig";
import {EnvironmentConfig} from "./EnvironmentConfig";

export class Slide {
  public id;
  public name;
  public sort;
  public image;
  public jsId;
  public config:SlideConfig;

  constructor(name, sort) {
    this.id = null;
    this.name = name;
    this.config = new SlideConfig();
    this.sort = sort;
    this.jsId = Date.now();
  }

  public setEnvironment(e:EnvironmentConfig) {
    this.config.environment.viewportWidth = e.viewportWidth;
    this.config.environment.viewportHeight = e.viewportHeight;
    this.config.environment.bounds = e.bounds;
    this.config.environment.heading = e.heading;
    this.config.environment.timeline = e.timeline;
    this.config.environment.hiddenGroups = e.hiddenGroups;
    this.config.environment.groupLabelsVisibility = e.groupLabelsVisibility;
    this.config.environment.imageryMode = e.imageryMode;
    this.config.environment.greyscale = e.greyscale;
    this.config.environment.hiddenItems = e.hiddenItems;
    this.config.environment.zoomLevel = e.zoomLevel;
    this.config.environment.labelsVisible = e.labelsVisible;
    this.config.environment.zoomLevelHeights = e.zoomLevelHeights;
    this.config.environment.prevSelectedMode = e.prevSelectedMode;
    this.config.environment.prevSelectedModeName = e.prevSelectedModeName;
    this.config.environment.prevSelectedModeVal = e.prevSelectedModeVal;

    this.config.environment.assign(e);
  }

  public equals(s:Slide) : boolean {
    return (
      s
      && this.name === s.name
    );
  }

  static fromConfig(v): Slide {
    let s = new Slide(v.name, v.sort);
    s.image = v.image;

    s.id = typeof v.id !== 'undefined' ? v.id : null;
    s.jsId = v.jsId;
    s.config.cameraLatitude = v.config.cameraLatitude;
    s.config.cameraLongitude = v.config.cameraLongitude;
    s.config.cameraHeight = v.config.cameraHeight;
    s.config.cameraPitch = v.config.cameraPitch;
    s.config.cameraRoll = v.config.cameraRoll;
    s.config.cameraHeading = v.config.cameraHeading;
    s.config.environment.componentConfigs = v.config.environment.componentConfigs;
    s.config.environment.viewportWidth = v.config.environment.viewportWidth;
    s.config.environment.viewportHeight = v.config.environment.viewportHeight;
    s.config.environment.bounds = v.config.environment.bounds;
    s.config.environment.heading = v.config.environment.heading;
    s.config.environment.timeline = v.config.environment.timeline;
    s.config.environment.hiddenGroups = v.config.environment.hiddenGroups;
    s.config.environment.groupLabelsVisibility = v.config.environment.groupLabelsVisibility;
    s.config.environment.hiddenItems = v.config.environment.hiddenItems;
    s.config.environment.zoomLevel = v.config.environment.zoomLevel;
    s.config.environment.imageryMode = v.config.environment.imageryMode;
    s.config.environment.prevSelectedMode = v.config.environment.prevselectedMode;
    s.config.environment.prevSelectedModeName = v.config.environment.prevSelectedModeName;
    s.config.environment.prevSelectedModeVal = v.config.environment.prevSelectedModeVal;
    s.config.environment.greyscale = v.config.environment.greyscale;
    s.config.environment.labelsVisible = v.config.environment.labelsVisible;
    return s;
  }
}


